import {
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import {
    CREATE_THIS_TRIP,
    EDIT_THIS_TRIP,
    REVISE_TRIP_CONFIRM_CONTENT,
    REVISE_TRIP_CONFIRM_TITLE
} from "../../UserVisibleStrings";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";

export enum ConfirmType
    {
    EDIT,
    CREATE
}
export interface ConfirmEditTypeDialogProps
{
    open: boolean;
    onClose: ( value: ConfirmType | undefined ) => void;
}

export default function ConfirmEditTypeDialog( props: ConfirmEditTypeDialogProps ): JSX.Element
{
    return (
        <Dialog onClose = {() => props.onClose( undefined )} open = {props.open}>
            <DialogTitle>{REVISE_TRIP_CONFIRM_TITLE}</DialogTitle>
            <DialogContent>
                {REVISE_TRIP_CONFIRM_CONTENT}

                <Box sx = {{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button
                        type = "submit"
                        size = "medium"
                        color = "secondary"
                        variant = "contained"
                        onClick = {() => props.onClose( ConfirmType.EDIT )}
                        sx = {{ margin: "15px" }}
                    >
                        {EDIT_THIS_TRIP}
                    </Button>
                    <Button
                        type = "submit"
                        size = "medium"
                        color = "primary"
                        variant = "contained"
                        onClick = {() => props.onClose( ConfirmType.CREATE )}
                        sx = {{ margin: "15px" }}
                    >
                        {CREATE_THIS_TRIP}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
